import React from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

import { formatPercent } from 'utils/helpers/numbers';

import { EMAIL_MATCHING_STATUS_FILTERS } from './constants';
import EmailMatchingAiSuggestion from './EmailMatchingAiSuggestion';
import EmailMatchingClassificationMatchingFieldsContainer from './EmailMatchingClassificationMatchingFieldsContainer';
import { EmailMatchingConfirmMatchPayloadType, EmailMatchingRecordType } from './types';

type Props = {
  detail: EmailMatchingRecordType;
  onValuesChange?: (values: EmailMatchingConfirmMatchPayloadType) => void;
};

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const SectionTitle = styled(Typography.Text)`
  display: block;
  font-family: var(--font-bold);
  font-size: 11px;
  text-transform: uppercase;
  color: var(--text-secondary);
`;

const EmailMatchingClassificationMatchingSection = ({ detail, onValuesChange }: Props) => {
  const confidence =
    detail.ai_community_match_confidence !== null ? formatPercent(detail.ai_community_match_confidence) : null;
  const showAiSuggestion = detail.status === EMAIL_MATCHING_STATUS_FILTERS.NEEDS_REVIEW;

  return (
    <Section>
      <SectionTitle>Classification & Matching</SectionTitle>
      {showAiSuggestion && (
        <EmailMatchingAiSuggestion
          communityName={detail.ai_matched_community_name}
          confidence={confidence}
          signals={detail.identity_signals ?? []}
        />
      )}
      <EmailMatchingClassificationMatchingFieldsContainer detail={detail} onValuesChange={onValuesChange} />
    </Section>
  );
};

export default EmailMatchingClassificationMatchingSection;
